import React from "react";
import Axios from "axios";
import axios from "services/axios";
import { Button, Card, message, Spin, Tooltip, Tag } from "antd";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import momentTZ from "moment-timezone";
import _ from "lodash";
import { getCarName, errorMessage } from "../../../../Utils";

import ModalDownload from "../../Component/Modal/ModalDownload";
import ModalReverse from "../../Component/Modal/ModalReverse";
import ModalConfirm from "../../Component/Modal/ModalConfirmOdoo";
import ModalSendToMobbi from "../../Component/Modal/ModalSendToMobbi";

let cancelToken;

class TradeInFinal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tradeIn: [],
      dataReverse: {},
      dataConfirm: {},
      isLoading: true,
      confirmLoading: false,
      disableButton: true,
      openModal: false,
      fileList: null,
      page: 1,
      limit: 15,
      count: 0,
      search: "",
      sort: { name: "date", direction: "desc" },
      visibleModalDownload: false,
      visibleModalReverse: false,
      visibleModalConfirm: false,
      visibleModalSendToMobbi: false,
      confirmLoading: false,
    };
    this.visibleModalDownload = this.visibleModalDownload.bind(this);
    this.sendToOdooButton = this.sendToOdooButton.bind(this);
    this.cancelApproval = this.cancelApproval.bind(this);
    this.sendToMobbi = this.sendToMobbi.bind(this);
    this.visibleModalSendToMobbi = this.visibleModalSendToMobbi.bind(this);
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    this.fetchTradeIn(this.state.page, this.state.limit);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.status !== this.props.match.params.status) {
      this.setState({ isLoading: true, search: "", page: 1, limit: 15 }, () =>
        this.fetchTradeIn(1, 15)
      );
    }
  }

  orderBy(sort) {
    let key = "date";
    let value = "DESC";

    //Get Key
    if (sort.name === "Mobil Bekas") key = "carName";
    else if (sort.name === "Mobil Baru") key = "newCar";
    else if (sort.name === "Salesman") key = "salesman";
    else if (sort.name === "Tanggal Selesai") key = "date";

    //Get Value
    if (sort.direction === "asc") value = "ASC";
    else if (sort.direction === "desc") value = "DESC";

    return `${key}=${value}`;
  }

  getStatus() {
    let status = this.props.match.params.status;
    if (!["deal", "no-deal"].includes(status)) status = null;
    return status;
  }

  async fetchTradeIn(page, limit) {
    const status = this.getStatus();
    if (status) {
      const order = this.orderBy(this.state.sort);
      const query = `${order}&&page=${page}&&limit=${limit}&&search=${
        this.state.search || ""
      }`;

      if (cancelToken) {
        cancelToken.cancel("Operation canceled due to new request");
      }
      cancelToken = Axios.CancelToken.source();

      const data = await axios
        .get(`admin-panel/trade-in/${status}?${query}`, {
          cancelToken: cancelToken.token,
        })
        .then((result) => {
          this.setState({
            tradeIn: result.data.approvalTradeIn,
            page: result.data.page,
            limit: result.data.limit,
            count: result.data.count,
            isLoading: false,
          });
        })
        .catch((err) => {
          if (!Axios.isCancel(err)) {
            errorMessage(err.response || err);
            this.setState({ isLoading: false });
          }
        });
    } else {
      message.error("Gagal request data trade in");
      this.setState({ isLoading: false });
    }
  }

  changePage(page, limit) {
    this.setState({ isLoading: true });
    this.fetchTradeIn(page, limit);
  }

  formatRupiah(number) {
    const data = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return data;
  }

  getMuiTheme = () =>
    createMuiTheme({
      typography: {
        useNextVariants: true,
      },
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            "white-space": "nowrap",
            "&:nth-child(1)": {
              width: "8em",
              "min-width": "8em",
              "max-width": "10em",
              "word-break": "break-all",
            },
          },
        },
      },
    });

  visibleModalDownload = (val) => {
    this.setState({ visibleModalDownload: val });
  };

  visibleModalReverse = (val, data) => {
    this.setState({ visibleModalReverse: val, dataReverse: data });
  };

  visibleModalConfirm = (val, data) => {
    if (val === "Confirm") {
      return this.setState({ visibleModalConfirm: data });
    }
    return this.setState({ visibleModalConfirm: val, dataConfirm: data });
  };

  visibleModalSendToMobbi = (val, data) => {
    this.setState({ visibleModalSendToMobbi: val, dataConfirm: data });
  };

  async cancelApproval(id) {
    this.setState({ confirmLoading: true });
    const data = await axios
      .put(`admin-panel/trade-in/cancel/${id}`)
      .then((result) => {
        message.success("Berhasil cancel Approval");
        this.setState({
          confirmLoading: false,
          visibleModalReverse: false,
          isLoading: true,
        });
        this.fetchTradeIn(this.state.page, this.state.limit);
      })
      .catch((err) => {
        message.error("Gagal Cancel Data Approval");
        this.setState({
          isLoading: false,
          confirmLoading: false,
          visibleModalReverse: false,
        });
      });
  }

  async sendToOdooButton(id) {
    try {
      this.setState({ confirmLoading: true, isLoading: true });
      await axios.put(`/admin-panel/trade-in/send-to-odoo/${id}`, {});
      this.setState({ confirmLoading: false, visibleModalConfirm: false });
      message.success("Success Send To Odoo");
      this.fetchTradeIn(1, this.state.limit);
    } catch (e) {
      if (e.response) {
        if (e.response.data || e.response.message) {
          message.error(
            e.response.data.message || e.response.message || e.response.data
          );
        } else {
          message.error("Error Send to Odoo");
        }
      } else {
        message.error("Error Send to Odoo");
      }
      this.setState({ confirmLoading: false, isLoading: false });
    }
  }

  async sendToMobbi(item) {
    try {
      this.setState({ confirmLoading: true, isLoading: true });
      let bookingId = _.get(item, "Appraisal.Booking.MobbiPayload.bookingId");
      await axios.put(
        `/admin-panel/mobbi/re-send-status/booking/${bookingId}`,
        {}
      );

      this.setState({ confirmLoading: false, visibleModalConfirm: false });
      message.success("Success Send To Mobbi");
      this.fetchTradeIn(1, this.state.limit);
    } catch (e) {
      if (e.response) {
        if (e.response.data || e.response.message) {
          message.error(
            e.response.data.message || e.response.message || e.response.data
          );
        } else {
          message.error("Error Send to Mobbi");
        }
      } else {
        message.error("Error Send to Mobbi");
      }
      this.setState({ confirmLoading: false, isLoading: false });
    }
  }

  getPotentialBuyer = (approval, no) => {
    let potentialBuyer = "-";
    let booking = _.get(approval, "Appraisal.Booking");
    if (booking && booking.sourceOfRequest === "MOBBI") {
      let mobbiPayload = booking.MobbiPayload;
      if (mobbiPayload) {
        if (no == 1) {
          if (mobbiPayload.isMobbi) potentialBuyer = "MOBBI88";
          else potentialBuyer = "TRUST";
        } else if (no == 2) {
          if (approval.approvalStatus == "No Deal") {
            if (mobbiPayload.isMobbi) potentialBuyer = "TRUST";
            else potentialBuyer = "MOBBI88";
          } else {
            if (mobbiPayload.isMobbi) potentialBuyer = "TRUST";
          }
        }
      }
    }
    return potentialBuyer;
  };

  isSendToMobbi = (approval) => {
    let isSendToMobbi = true;
    let booking = _.get(approval, "Appraisal.Booking");

    if (booking && booking.sourceOfRequest === "MOBBI") {
      let mobbiPayload = booking.MobbiPayload;
      if (mobbiPayload) {
        if (
          mobbiPayload.isSendCancelToMobbi == false &&
          mobbiPayload.isSendPriceNegoToMobbi == false
        ) {
          isSendToMobbi = false;
        }
      }
    }
    return isSendToMobbi;
  };

  isShowReverseButton = (approval) => {
    let isShow = true;
    let booking = _.get(approval, "Appraisal.Booking");

    if (booking && booking.sourceOfRequest === "MOBBI") {
      if (approval.approvalStatus === "No Deal") isShow = false;
    }
    return isShow;
  };

  isStatusMobbi = (approval) => {
    let isStatusMobbi = true;
    let booking = _.get(approval, "Appraisal.Booking");

    if (booking && booking.sourceOfRequest === "MOBBI") {
      let mobbiPayload = booking.MobbiPayload;
      if (mobbiPayload) {
        if (
          mobbiPayload.isSendCancelToMobbi == false &&
          mobbiPayload.isSendPriceNegoToMobbi == false
        ) {
          isStatusMobbi = false;
        }
      }
    }
    return isStatusMobbi;
  };

  getApprovalStatusContent(approval) {
    if (approval.approvalStatus === "Deal") {
      return approval.sendToOdooStatus ? (
        <Tag color="green" style={{ minWidth: 90, textAlign: "center" }}>
          <p style={{ marginBottom: 0 }}>Confirmed</p>
          <p style={{ marginBottom: 0 }}>to Odoo</p>
        </Tag>
      ) : (
        <Tag color="magenta" style={{ minWidth: 90, textAlign: "center" }}>
          <p style={{ marginBottom: 0 }}>Waiting</p>
          <p style={{ marginBottom: 0 }}>confirmation</p>
        </Tag>
      );
    }

    let mobbiPayload = _.get(approval, "Appraisal.Booking.MobbiPayload");
    if (!mobbiPayload) return "-";

    let isStatusMobbi = this.isStatusMobbi(approval);
    return isStatusMobbi ? (
      <Tag color="green" style={{ minWidth: 90, textAlign: "center" }}>
        <p style={{ marginBottom: 0 }}>Sent</p>
        <p style={{ marginBottom: 0 }}>to Mobbi</p>
      </Tag>
    ) : (
      <Tag color="magenta" style={{ minWidth: 90, textAlign: "center" }}>
        <p style={{ marginBottom: 0 }}>Waiting</p>
        <p style={{ marginBottom: 0 }}>confirmation</p>
      </Tag>
    );
  }

  render() {
    //Columns
    const columns = [
      {
        name: "Action",
        options: {
          sort: false,
        },
      },
      {
        name:
          this.props.match.params.status === "deal"
            ? "Status Odoo"
            : "Status Mobbi",
        options: {
          sort: false,
        },
      },
      {
        name: "Status Approval",
        options: {
          sort: false,
        },
      },
      {
        name: "Potential Buyer 1",
      },
      {
        name: "Potential Buyer 2",
      },
      {
        name: "Mobbi Id",
      },
      {
        name: "No Booking",
        options: {
          sort: false,
        },
      },
      {
        name: "Nomor Polisi",
        options: {
          sort: false,
        },
      },
      {
        name: "Mobil Bekas",
        options: {
          sort: true,
        },
      },
      {
        name: "Mobil Baru",
        options: {
          sort: true,
        },
      },
      {
        name: "Salesman",
        options: {
          sort: true,
        },
      },
      {
        name: "Cabang",
        options: {
          sort: false,
        },
      },
      {
        name: "Area",
        options: {
          sort: false,
        },
      },
      {
        name: "Tanggal Selesai",
        options: {
          sort: true,
        },
      },
    ];

    //Data New Car
    const tradeIn = this.state.tradeIn.map((item, idx) => {
      const carName = getCarName(item.Appraisal.carDetail);
      const isSendToMobbi = this.isSendToMobbi(item);
      let mobbiId = _.get(item, "Appraisal.Booking.MobbiPayload.mobbiId");
      let isShowReverseButton = this.isShowReverseButton(item);
      return [
        <div>
          <Link
            to={{
              pathname: `/home/approval/trade-in-final/${item.id}`,
              query: { status: this.props.match.params.status },
            }}>
            <Tooltip placement="bottom" title="Detail Trade In">
              <Button icon="bars" style={{ marginRight: 10 }} />
            </Tooltip>
          </Link>
          {isShowReverseButton && (
            <Tooltip placement="bottom" title="Reverse Approval">
              <Button
                style={{ marginRight: 10 }}
                disabled={item.sendToOdooStatus}
                icon="retweet"
                type="danger"
                onClick={() => this.visibleModalReverse(true, item)}
              />
            </Tooltip>
          )}
          {item.approvalStatus === "Deal" && (
            <Tooltip placement="bottom" title="Send To Odoo">
              <Button
                style={
                  item.sendToOdooStatus
                    ? {}
                    : {
                        backgroundColor: "#52c41a",
                        color: "white",
                      }
                }
                disabled={item.sendToOdooStatus}
                icon="check"
                onClick={() => this.visibleModalConfirm(true, item)}
              />
            </Tooltip>
          )}

          {item.approvalStatus === "No Deal" && (
            <Tooltip placement="bottom" title="Send To Mobbi">
              <Button
                style={
                  isSendToMobbi
                    ? {}
                    : {
                        backgroundColor: "#52c41a",
                        color: "white",
                      }
                }
                disabled={isSendToMobbi}
                icon="check"
                onClick={() => this.visibleModalSendToMobbi(true, item)}
              />
            </Tooltip>
          )}
        </div>,
        this.getApprovalStatusContent(item),

        <Tag color={item.approvalStatus === "Deal" ? "green" : "magenta"}>
          {" "}
          {item.approvalStatus}{" "}
        </Tag>,
        this.getPotentialBuyer(item, 1),
        this.getPotentialBuyer(item, 2),
        mobbiId,
        item.Appraisal.Booking.noBooking,
        item.Appraisal.licensePlate,
        item.Appraisal.carName || carName,
        item.NewCar ? item.NewCar.carName : null,
        item.Appraisal.Booking.SalesProfile.name,
        item.Appraisal.Booking.SalesProfile.SalesBranch.branch,
        item.Appraisal.Booking.SalesProfile.SalesBranch.area,
        momentTZ(item.updatedAt)
          .tz("Asia/Jakarta")
          .format("dddd, D MMMM YYYY HH:mm"),
      ];
    });

    //Options
    const options = {
      filter: false,
      responsive: "simple",
      fixedHeader: true,
      tableBodyHeight: "460px",
      print: false,
      selectableRows: "none",
      // resizableColumns: true,
      download: false,
      viewColumns: false,
      serverSide: true,
      rowsPerPage: this.state.limit,
      count: this.state.count,
      page: this.state.page - 1,
      searchText: this.state.search,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.changePage(tableState.page + 1, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.changePage(1, tableState.rowsPerPage);
            break;
          case "search":
            this.setState({ search: tableState.searchText }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          case "sort":
            this.setState({ sort: tableState.sortOrder }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          default:
            break;
        }
      },
    };

    return (
      <Card
        title="List Trade In Final"
        style={{
          marginTop: 35,
          background: "#fff",
          minHeight: 360,
        }}>
        <div style={{ marginBottom: 10 }}>
          <Button onClick={() => this.visibleModalDownload(true)}>
            Download Report
          </Button>
        </div>

        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title="List Trade In Final"
              data={tradeIn}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        </Spin>

        <ModalDownload
          visible={this.state.visibleModalDownload}
          visibleModal={this.visibleModalDownload}
          status={this.props.match.params.status}
        />

        <ModalReverse
          confirmLoading={this.state.confirmLoading}
          data={this.state.dataReverse}
          type="approval"
          visible={this.state.visibleModalReverse}
          visibleModal={this.visibleModalReverse}
          cancelApproval={this.cancelApproval}
        />

        <ModalConfirm
          confirmLoading={this.state.confirmLoading}
          data={this.state.dataConfirm}
          visible={this.state.visibleModalConfirm}
          sendButton={this.sendToOdooButton}
          visibleModal={this.visibleModalConfirm}
        />

        <ModalSendToMobbi
          confirmLoading={this.state.confirmLoading}
          data={this.state.dataConfirm}
          visible={this.state.visibleModalSendToMobbi}
          sendButton={this.sendToMobbi}
          visibleModal={this.visibleModalSendToMobbi}
        />
      </Card>
    );
  }
}

export default TradeInFinal;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/TradeIn/Final/TradeIn.js